export default {
    guidelines: {
        intro: 'Please note that your password must meet the following criteria:',
        top1: 'Your password must contain at least 8 characters.',
        top2: 'Use at least one uppercase and one lowercase letter.',
        top3: 'Use at least one number and one special character.'
    },
    action: 'Submit password'
}
